import { render, staticRenderFns } from "./PresentationEditorGoogleSlidePage.vue?vue&type=template&id=5ece6775&"
import script from "./PresentationEditorGoogleSlidePage.vue?vue&type=script&lang=js&"
export * from "./PresentationEditorGoogleSlidePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports